<template>
  <div class="octobus__modal" :class="{ 'is-active' : show }">
    <div class="octobus__modal-background"></div>
    <div class="octobus__modal-card">
      <header class="octobus__modal-card-head">
        <p class="octobus__modal-card-title"></p>
        <button class="octobus__delete" aria-label="close" @click="onHideModal"></button>
      </header>
      <section class="octobus__modal-card-body">
        <span class="has-text-danger">
          <font-awesome-icon :icon="errorIcon" :size="'2x'" />
        </span>
        <p class="error has-text-centered">{{error}}</p>
      </section>
      <footer class="octobus__modal-card-foot">
        <button class="octobus__button is-primary" @click="onHideModal">{{ $t('errorModal.hide') }}</button>
      </footer>
    </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import { faExclamationCircle } from '@fortawesome/fontawesome-free-solid';

export default {
  name: 'ErrorModal',
  components: {
    FontAwesomeIcon,
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false;
      },
    },
    error: {
    },
  },
  methods: {
    onHideModal() {
      this.$emit('hideModal');
    },
  },
  computed: {
    errorIcon() {
      return faExclamationCircle;
    },
  },
};
</script>

<style lang="scss" scoped>
  #app {
    .octobus__modal-card-body {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      .error {
        flex-grow: 1;
      }
    }

    .octobus__modal-card-foot {
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_common/ErrorModal.vue